import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const isDark = tone === 'dark';
  const boxClass = isDark ? 'bg-white/10 text-white ring-1 ring-white/20' : 'bg-[#0E3B42] text-white';
  const labelClass = isDark ? 'text-white/60' : 'text-[#4A6B70]';
  const titleClass = isDark ? 'text-white/70' : 'text-[#8A6314]';
  const colonClass = isDark ? 'text-white/40' : 'text-[#0E3B42]/40';
  const units: Array<{
    value: number;
    label: string;
  }> = [{
    value: hours,
    label: 'Ore'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="flex flex-col items-center" data-id="element-18" data-mp="17qq64md98boq">
      <p className={`text-[11px] font-extrabold uppercase tracking-[0.18em] ${titleClass}`} data-id="element-19" data-mp="17qge6t8nfuge">
        L’offerta di lancio termina tra
      </p>
      <div className="mt-3 flex items-start gap-1.5" role="timer" aria-live="off" aria-label={`Offerta valida ancora per ${pad(hours)} ore ${pad(minutes)} minuti ${pad(seconds)} secondi`} data-id="element-20" data-mp="f1smaetea6tv">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-21" data-mp="o0nu1vc37oza" data-mpi={index}>
            <div className="flex flex-col items-center" data-id="element-22" data-mp="k15i3p28uo8l">
              <span className={`flex min-w-[3.25rem] justify-center rounded-lg px-2 py-2 font-display text-2xl font-bold tabular-nums sm:min-w-[3.75rem] sm:text-3xl ${boxClass}`} data-id="element-23" data-mp="k3rqts0vf9se">
                {pad(unit.value)}
              </span>
              <span className={`mt-1.5 text-[10px] font-bold uppercase tracking-[0.14em] ${labelClass}`} data-id="element-24" data-mp="s54xt5c6dlmu">
                {unit.label}
              </span>
            </div>
            {index < units.length - 1 ? <span className={`pt-1.5 font-display text-2xl font-bold sm:text-3xl ${colonClass}`} aria-hidden="true" data-id="element-25" data-mp="165610rfwx55h">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
    </div>;
}